import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { getMalluUrls, scrollToMalluSection } from "./MalluNav";
import { MalluHero } from "./MalluHero";
import {
  MalluApp,
  MalluBusiness,
  MalluCard,
  MalluFaq,
  MalluPix,
  MalluSecurity,
  MalluValues,
} from "./MalluSections";
import { useMotionLevel, useReveal } from "./malluMotion";
import "./mallu.css";

/**
 * Landing "/" da Mallu Pay — port do design "Mallu Pay - Landing.dc.html".
 * O topo (MalluNav) e o rodapé (MalluFooter) são montados em App.jsx.
 */
const MalluLanding = () => {
  const location = useLocation();
  const pageRef = useRef(null);
  const motion = useMotionLevel();
  const urls = getMalluUrls();

  useReveal(pageRef);

  // Navegação por hash (/#pix etc.) vinda de outras rotas ou de link direto.
  useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.replace(/^#/, "");
    if (!id) return undefined;
    const timer = window.setTimeout(() => scrollToMalluSection(id), 120);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <main
      ref={pageRef}
      className="pp-page"
      style={{ "--play": motion ? "running" : "paused" }}
    >
      <MalluHero urls={urls} motion={motion} />
      <MalluValues />
      <MalluCard motion={motion} />
      <MalluPix />
      <MalluSecurity />
      <MalluBusiness urls={urls} />
      <MalluFaq />
      <MalluApp urls={urls} motion={motion} />
    </main>
  );
};

export default MalluLanding;
